import { Injectable } from '@angular/core';
import { of, Observable, Subject } from 'rxjs';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { DropdownQuestion } from '../../question-dropdown';
import { TextboxQuestion } from '../../question-textbox';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';

@Injectable({
  providedIn: 'root',
})
export class EcontentServicesService {
  shiftdropdata: any = [];
  Coursesdata: any = [];
  semister_drop: any = [];
  subjects_drop: any = [];
  catogory_drop: any = [];
  studentEcontentData: any;

  selectedCourseValue: number = 0;
  selectedAccademichValue: any;
  selectedSemesterValue: number = 0;
  public formcls = {};
  public showForm = false;
  private notifyStdEcontentSubject = new Subject<void>();
  notifyStdEcontentSubject$ = this.notifyStdEcontentSubject.asObservable();


  constructor(private dropdownservice: DropdownservicesService, private apiservices: ApiservicesService, private connectiveServices : ConnectiveservicesService) {
    // this.loadDropdownData('COURSES', this.Coursesdata);
    // this.loadDropdownData('CONTENT_CATEGORIES', this.catogory_drop);
  }

   resetdropdowns(){
    this.semister_drop.splice(0, this.semister_drop.length);
    this.Coursesdata.splice(0, this.Coursesdata.length);
    this.subjects_drop.splice(0, this.subjects_drop.length);
   }

  loadDropdownData(code: string, dataArray: any[] = []) {
    let observable: Observable<any>;

    if (code === 'ORGANISATION') {
      observable = this.dropdownservice.getorganizationdrop();
    } else if (code === 'COURSES') {
      observable = this.dropdownservice.getcoursesbybatch(
        this.selectedAccademichValue
      );
    } else if (code === 'SEMISTER') {
      observable = this.dropdownservice.getcoursewisesemester({
        course_ID: this.selectedCourseValue,
      });
    } else if (code === 'SUBJECTS') {
      observable = this.dropdownservice.getecontentsubjectsdrop({
        course_ID: this.selectedCourseValue,
        semester_ID: this.selectedSemesterValue,
      });
    } else {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }
    observable.subscribe((res) => {
      const tempData: any[] = [];

      for (let i = 0; i < res?.length; i++) {
        let lookupname;
        if (code === 'SEMISTER') {
          lookupname = res[i]?.name;
        } else if (code === 'COURSES') {
          if (res[i]?.medium_name !== 'ENGLISH') {
            lookupname = res[i]?.name + '(' + res[i]?.medium_name + ')';
          } else {
            lookupname = res[i]?.name;
          }
        } else if (code === 'SUBJECTS') {
          lookupname = res[i]?.subject_name;
        } else {
          lookupname = res[i].lookup_name;
        }

        if (lookupname != null) {
          tempData.push({
            id: code === 'SUBJECTS' ? res[i].subject_id : res[i].id,
            key: lookupname,
            value: code === 'SUBJECTS' ? res[i].subject_id : res[i].id,
          });
        }
      }

      // Replace the old array completely (prevent duplicates)
      dataArray.length = 0;
      dataArray.push(...tempData);
    });
  }
  onCourseChange(selectedValue: any): void {
    this.selectedCourseValue = selectedValue;
    this.semister_drop.splice(0, this.semister_drop.length);
    this.subjects_drop.splice(0, this.subjects_drop.length);
    this.loadDropdownData('SEMISTER', this.semister_drop);
  }

  onSemesterChange(selectedValue: any): void {
    this.selectedSemesterValue = selectedValue;
    this.subjects_drop.splice(0, this.subjects_drop.length);
    this.loadDropdownData('SUBJECTS', this.subjects_drop);
  }

  studentEcontentFunction(){
    this.notifyStdEcontentSubject.next();
  }

  getecontentform() {
    this.resetdropdowns();
    this.loadDropdownData('COURSES', this.Coursesdata);
    this.loadDropdownData('CONTENT_CATEGORIES', this.catogory_drop);

    const questions: Inputfiledsbase<string>[] = [
      new DropdownQuestion({
        key: 'courses_id',
        label: 'Courses',
        options: this.Coursesdata,
        required: true,
        order: 1,
        onChange: this.onCourseChange.bind(this),
      }),
      new DropdownQuestion({
        key: 'semister_id',
        label: 'Semister',
        options: this.semister_drop,
        required: true,
        order: 2,
        onChange: this.onSemesterChange.bind(this),
      }),
      new DropdownQuestion({
        key: 'courses_medium',
        label: 'Medium',
        options: [],
        required: false,
        order: 3,
        // onChange: this.onCourseChange.bind(this),
      }),
      new DropdownQuestion({
        key: 'subject_id',
        label: 'Subject',
        options: this.subjects_drop,
        required: true,
        order: 4,
      }),
      new DropdownQuestion({
        key: 'category_id',
        label: 'Category',
        options: this.catogory_drop,
        required: true,
        order: 5,
      }),
      new TextboxQuestion({
        key: 'econtent_title',
        label: 'E-content Title',
        required: true,
        order: 6,
      }),

    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
  showecontentdocform() {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'econtent_title',
        label: 'E-content Title',
        required: true,
        order: 1,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }

  getstudentsemesterform() {
    this.resetdropdowns();
    this.apiservices.getEcontentStdSemList(this.connectiveServices.getuserdata()?.data?.id).subscribe({
      next: (res: any) => {
        if (res) {
          for (let i = 0; i < res?.semesters.length; i++) {
            if (res.semesters[i].semester_number != null) {
              this.semister_drop.push({
                id: res.semesters[i].id,
                key: res.semesters[i].semester_number,
                value: res.semesters[i].id,
              });
            }
          }
        } else {
          console.error('No semesters found.');
        }
      },
      error: (err) => {
        console.error('Failed to fetch semesters:', err);
      },
    });

    const questions: Inputfiledsbase<string>[] = [
      new DropdownQuestion({
        key: 'semester',
        label: 'Semister',
        options: this.semister_drop,
        required: false,
        order: 1,
        onChange: this.studentEcontentFunction.bind(this),
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }

  setformcls(obj: Object) {
    this.formcls = obj;
  }

  getformCls() {
    return this.formcls;
  }

  setshowform(flag: boolean) {
    this.showForm = flag;
  }

}
